<template>
    <div class="gs-order-bump-editor gs-order-bump-editor--presell">
        <div v-if="!selectedPricePointId" class="gs-order-bump-editor__toolbar">
            <div>
                <label>Price point</label>
                <p>Choose the price point this pre-sell bump belongs to.</p>
            </div>
            <select v-model="pricePointsTab" class="gs-order-bump-editor__select">
                <option v-for="tab in pricePointsTabs" :key="tab.value" :value="tab.value">
                    {{ tab.title }}
                </option>
            </select>
        </div>
        <div class="mt-4">
            <div v-for="(pricePoint, index) in localModel.pricing_points" :key="index">
                <div v-if="pricePointsTab === 'price_point_' + pricePoint.id" class="gs-order-bump-editor__panel">
                    <div class="gs-order-bump-editor__section">
                        <div class="gs-order-bump-editor__activation">
                            <button
                                v-for="(bumpType, bumpIndex) in (pricePoint.price > 0 ? orderBumpStatus : orderBumpTypesForFreePricePoint)"
                                :key="bumpIndex"
                                type="button"
                                class="gs-order-bump-editor__choice"
                                :class="{ 'is-selected': isActivationChoiceSelected(pricePoint, bumpType.id), 'is-disabled': bumpType.is_disabled }"
                                :disabled="bumpType.is_disabled"
                                @click="!bumpType.is_disabled && setBumpActivation(bumpType.id)"
                            >
                                <span></span>
                                <strong>{{ bumpType.title }}</strong>
                                <small>{{ bumpType.description }}</small>
                            </button>
                        </div>
                    </div>

                    <slot name="after-activation"></slot>

                    <div v-if="isPricePointBumpEnabled(pricePoint)" class="w-full flex flex-col">
                        <div class="flex flex-col w-full" v-if="pricePoint.offer_bump_options &&
                            pricePoint.offer_bump_options.length > 0
                            ">
                            <div class="flex flex-col w-full" :key="offerBumpIndex" v-for="(
                        offerBump, offerBumpIndex
                      ) in pricePoint.offer_bump_options">
                                <hr v-if="offerBumpIndex > 0" class="border-grey-100 -mx-4" />
                                <div class="gs-order-bump-editor__bump-head">
                                    <div>
                                        <gd-button v-if="offerBumpIndex == 0" size="auto" variant="primary" class="mt-3"
                                            @click="createOfferBump(index)">+ {{ $t('frontend_add_presale_bump')
                                            }}</gd-button>
                                    </div>
                                    <div>
                                        <gd-button variant="outline" size="icon" class="mr-2"
                                            @click="openConfirmModal(index, offerBumpIndex)">
                                            <trash-icon class="h-5 w-5 fill-current"/>
                                        </gd-button>
                                    </div>
                                </div>
                                <div class="gs-order-bump-editor__content">
                                    <div class="gs-order-bump-editor__form">
                                        <div class="w-full flex flex-col mb-6">
                                            <label class="font-semibold text-sm text-grey-700 mb-2">{{
                                                $t('frontend_heading') }}</label>
                                            <div class="w-full flex flex-row">
                                                <div class="w-full mr-2">
                                                    <text-input
                                                        v-model="offerBump.heading_line"
                                                        :validator="$v.localModel.pricing_points.$each[index].offer_bump_options.$each[offerBumpIndex].heading_line"
                                                        :attribute="$t('frontend_heading')" value="offerBump.heading_line"
                                                        :placeholder="$t('frontend_heading')"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-full flex flex-col mb-6">
                                            <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_desc')
                                            }}</label>
                                            <div class="w-full flex flex-row">
                                                <div class="w-full mr-2">
                                                    <quill-editor ref="preSellOrderBumpEditor"
                                                        v-model="offerBump.description"
                                                        :options="postSellOrderBumpEditorOptions"
                                                        :class="{'invalid': $v.localModel.pricing_points.$each[index].offer_bump_options.$each[offerBumpIndex].description.$error}"
                                                        class="h-32"
                                                    ></quill-editor>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="flex flex-col w-full mb-6 mt-8">
                                            <label class="font-semibold text-sm text-grey-700 mb-2">{{
                                                $t('frontend_product') }}</label>
                                            <gs-name-select
                                                v-model="offerBump.product_id"
                                                size="full"
                                                :options="pricePointFunnelProductsOptions(pricePoint)"
                                            />
                                        </div>
                                        <div class="flex flex-col w-full mb-6">
                                            <label class="font-semibold text-sm text-grey-700 mb-2">{{
                                                $t('frontend_price_point') }}</label>
                                            <gs-name-select
                                                v-model="offerBump.price_point_id"
                                                size="full"
                                                :options="selectedProductPricePointsOptions(pricePoint, offerBump.product_id)"
                                            />
                                        </div>
                                        <div class="w-full flex flex-col mb-6">
                                            <label class="font-semibold text-sm text-grey-700 mb-2">{{ $t('frontend_style')
                                            }}</label>
                                            <div class="w-full flex flex-row">
                                                <gd-dropdown
                                                    v-model="offerBump.style_id"
                                                    size="full"
                                                    :options="styleOptionsList"
                                                />
                                            </div>
                                        </div>
                                        <div class="w-full flex flex-col mb-8">
                                            <div class="w-full flex">
                                                <div class="flex flex-col w-1/2">
                                                    {{ $t('frontend_display_thumbnail') }}
                                                    <gd-toggle :aria-label="$t('frontend_display_thumbnail')" v-model="offerBump.display_thumbnail" />
                                                </div>

                                                <div class="flex flex-col w-1/2">
                                                    {{ $t('frontend_display_bouncing_arrow') }}
                                                    <gd-toggle :aria-label="$t('frontend_display_bouncing_arrow')" v-model="offerBump.display_bouncing" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="gs-order-bump-editor__preview">
                                        <div class="w-full flex flex-col mb-6">
                                            <label class=" w-full text-grey-dark text-sm font-semibold mb-32">{{ $t('frontend_preview') }}</label>
                                            <div v-if="offerBump.product_id && offerBump.price_point_id" class="w-full flex flex-row">
                                                <div class="w-full mr-2">
                                                    <style1 v-if="offerBump.style_id == 1" :key="offerBumpComponentKey"
                                                        :heading="offerBump.heading_line"
                                                        :description="offerBump.description"
                                                        :arrow="offerBump.display_bouncing"
                                                        :thumbnail="offerBump.display_thumbnail"
                                                        :selected-pricepoint="offerBump.price_point_id"
                                                        :selected-product="offerBump.product_id"
                                                        :all-products="pricePoint.funnelProducts" />
                                                    <style2 v-if="offerBump.style_id == 2" :key="offerBumpComponentKey"
                                                        :heading="offerBump.heading_line"
                                                        :description="offerBump.description"
                                                        :arrow="offerBump.display_bouncing"
                                                        :thumbnail="offerBump.display_thumbnail"
                                                        :selected-pricepoint="offerBump.price_point_id"
                                                        :selected-product="offerBump.product_id"
                                                        :all-products="pricePoint.funnelProducts" />
                                                    <style3 v-if="offerBump.style_id == 3" :key="offerBumpComponentKey"
                                                        :heading="offerBump.heading_line"
                                                        :description="offerBump.description"
                                                        :arrow="offerBump.display_bouncing"
                                                        :thumbnail="offerBump.display_thumbnail"
                                                        :selected-pricepoint="offerBump.price_point_id"
                                                        :selected-product="offerBump.product_id"
                                                        :all-products="pricePoint.funnelProducts" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="flex flex-col w-full">
                                <div class="gs-order-bump-editor__empty">
                                    <div>
                                        <gd-button size="auto" variant="primary" class="mt-3" @click="createOfferBump(index)">
                                            <plus-icon class="h-5 w-5 fill-current"/>
                                            {{ $t('frontend_add_presale_bump') }}
                                        </gd-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <gs-alert-dialog
            v-model="showDeleteOfferBumpConfirm"
            title="Delete order bump?"
            :copy="$t('frontend_non_revertable')"
            confirm-label="Delete"
            cancel-label="Cancel"
            @confirm="deleteOfferBump"
        />
    </div>
</template>
<script>
import { Quill, quillEditor } from 'vue-quill-editor';
import Style3 from '@/components/Style3.vue';
import Style2 from '@/components/Style2.vue';
import Style1 from '@/components/Style1.vue';
import TrashIcon from '@/assets/images/icons/TrashIcon.svg';
import PlusIcon from '@/assets/images/icons/PlusIcon.svg';
import {
  required,
  minLength,
  requiredIf,
} from 'vuelidate/lib/validators';

export default {
    components: {
        Quill,
        quillEditor,
        Style1,
        Style2,
        Style3,
        TrashIcon,
        PlusIcon,
    },
    props: {
        model: {
            required: true
        },
        selectedPricePointId: {
            default: null,
        },
        isBumpEnabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            localModel: this.model,
            pricePointsTab: '',
            orderBumpStatus: [
                {
                    id: 0,
                    title: this.$t('frontend_product_step6_no_dont'),
                    description: this.$t('frontend_product_step6_the_checkout'),
                },
                {
                    id: 1,
                    title: this.$t('frontend_product_step6_yes_activate'),
                    description: this.$t('frontend_product_step6_the_checkout_page'),
                },
            ],
            orderBumpTypesForFreePricePoint: [
                {
                    id: 0,
                    title: this.$t('frontend_product_step6_no_dont'),
                    description: this.$t('frontend_product_step6_the_checkout'),
                },
                {
                    id: 1,
                    title: this.$t('frontend_product_step6_yes_activate'),
                    description: this.$t('frontend_product_step6_the_checkout_page'),
                    is_disabled: true,
                },
            ],
            postSellOrderBumpEditorOptions: {
                modules: {
                    toolbar: [
                        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                        [{ header: [1, 2, 3, 4, 5, 6, false] }],

                        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                    ],
                },
            },
            styleOptionsList: [
                { text: `${this.$t('frontend_style')} 1`, value: 1 },
                { text: `${this.$t('frontend_style')} 2`, value: 2 },
                { text: `${this.$t('frontend_style')} 3`, value: 3 },
            ],
            offerBumpComponentKey: 1,
            offerBumpIndex: null,
            pricingPointIndex: null,
            showDeleteOfferBumpConfirm: false,
        }
    },
    computed: {
        pricePointsTabs() {
            const pricePointTabs = [];
            for (let i = 0; i < this.localModel.pricing_points.length; i++) {
                pricePointTabs.push({
                    title: this.localModel.pricing_points[i].name,
                    value: `price_point_${this.localModel.pricing_points[i].id}`,
                });
            }
            return pricePointTabs;
        },
        pricePointsErrorTabs() {
            const pricePointErrorTabs = [];

            let pricePointIndex;
            for (pricePointIndex in this.$v.localModel.pricing_points.$each.$iter) {
                if (
                this.$v.localModel.pricing_points.$each.$iter[pricePointIndex].$error
                ) {
                pricePointErrorTabs.push(
                    `price_point_${this.$v.localModel.pricing_points.$each.$iter[pricePointIndex].$model.id}`
                );
                }
            }

            return pricePointErrorTabs;
        },
    },
    mounted() {
        this.syncSelectedPricePoint();
    },
    watch:{
        selectedPricePointId() {
            this.syncSelectedPricePoint();
        },
        localModel: {
            handler: function (val, oldVal) {
                this.$emit('update-model', val);
            },
            deep: true
        }
    },
    methods: {
        async changedProduct(pPoint, event) {},

        handlePricePointsTabChange(tab) {
            this.pricePointsTab = tab;
        },
        syncSelectedPricePoint() {
            if (this.selectedPricePointId) {
                this.pricePointsTab = `price_point_${this.selectedPricePointId}`;
                return;
            }

            if (this.pricePointsTab == '' && this.localModel.pricing_points.length > 0) {
                this.pricePointsTab = `price_point_${this.localModel.pricing_points[0].id}`;
            }
        },
        isSelectedPricePoint(pricePoint) {
            return this.selectedPricePointId && pricePoint.id === this.selectedPricePointId;
        },
        isPricePointBumpEnabled(pricePoint) {
            return this.isSelectedPricePoint(pricePoint) ? this.isBumpEnabled : !!Number(pricePoint.offer_bump_enable);
        },
        isActivationChoiceSelected(pricePoint, value) {
            const enabled = this.isPricePointBumpEnabled(pricePoint);
            return Number(value) === (enabled ? 1 : 0);
        },
        setBumpActivation(value) {
            this.$emit('set-bump-enabled', {
                enabled: Number(value) === 1,
                type: 'presell',
            });
        },
        createOfferBump(index) {
            if (!this.localModel.pricing_points[index].offer_bump_options) {
                this.$set(this.localModel.pricing_points[index], 'offer_bump_options', []);
            }

            this.localModel.pricing_points[index].offer_bump_options.push({
                display_thumbnail: 0,
                display_bouncing: 0,
                heading_line: '',
                description: '',
                style_id: 1,
                product_id: 0,
                price_point_id: 0,
            });
        },
        openConfirmModal(pricingPointIndex, offerBumpIndex) {
            this.pricingPointIndex = pricingPointIndex;
            this.offerBumpIndex = offerBumpIndex;
            this.showDeleteOfferBumpConfirm = true;
        },
        deleteOfferBump() {
            this.localModel.pricing_points[this.pricingPointIndex].offer_bump_options.splice(
                this.offerBumpIndex,
                1
            );
        },
        pricePointFunnelProductsOptions(pricePoint) {
            return pricePoint.funnelProducts.map((product) => {
                return {
                    text: product.name,
                    value: product.id,
                };
            });
        },
        selectedProductPricePointsOptions(pricePoint, productId) {
            const funnelProduct = pricePoint.funnelProducts.find(
                (product) => product.id == productId
            );

            if (funnelProduct) {
                return funnelProduct.price_points.map((pricePoint) => {
                    return {
                        text: pricePoint.name,
                        value: pricePoint.id,
                    };
                });
            }
            return [];
        },
        selectedProductPricePoints(pricePoint, productId) {
            const funnelProduct = pricePoint.funnelProducts.find(
                (product) => product.id == productId
            );

            if (funnelProduct) {
                return funnelProduct.price_points;
            }
            return [];
        },
    },
    validations: {
        localModel: {
            pricing_points: {
                required,
                minLength: minLength(1),
                $each: {
                    offer_bump_options: {
                        $each: {
                            heading_line: {
                                required: requiredIf((object, value) => {
                                    if (object) {
                                        return true;
                                    }

                                    return false;
                                }),
                            },
                            description: {
                                required: requiredIf((object, value) => {
                                    if (object) {
                                        return true;
                                    }

                                    return false;
                                }),
                            },
                        },
                    },
                },
            },
        },
    },
}
</script>

<style scoped>
.gs-order-bump-editor {
    color: var(--gs-foreground);
    overflow-x: hidden;
}

.gs-order-bump-editor__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    padding: 16px 18px;
    margin-bottom: 18px;
    background: var(--gs-surface-subtle);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
}

.gs-order-bump-editor__toolbar label {
    display: block;
    color: var(--gs-foreground);
    font-size: 16px;
    font-weight: 600;
    line-height: 1.25;
}

.gs-order-bump-editor__toolbar p {
    margin: 4px 0 0;
    color: var(--gs-muted-foreground);
    font-size: 14px;
    line-height: 1.35;
}

.gs-order-bump-editor__select {
    width: min(360px, 44%);
    min-height: 44px;
    padding: 0 14px;
    color: var(--gs-foreground);
    font-size: 15px;
    font-weight: 500;
    background: #fff;
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-sm);
}

.gs-order-bump-editor__panel {
    min-width: 0;
}

.gs-order-bump-editor__section {
    margin-bottom: 20px;
}

.gs-order-bump-editor__activation {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    max-width: 640px;
}

.gs-order-bump-editor__choice {
    display: grid;
    grid-template-columns: 22px minmax(0, 1fr);
    gap: 6px 12px;
    min-height: 112px;
    padding: 18px;
    text-align: left;
    background: var(--gs-surface);
    border: 1px solid var(--gs-border);
    border-radius: var(--gs-radius-md);
    cursor: pointer;
}

.gs-order-bump-editor__choice span {
    width: 22px;
    height: 22px;
    border: 2px solid var(--gs-border-strong);
    border-radius: 50%;
}

.gs-order-bump-editor__choice strong {
    color: var(--gs-foreground);
  font-size: 15px;
  font-weight: 650;
    line-height: 1.25;
}

.gs-order-bump-editor__choice small {
    grid-column: 2;
    color: var(--gs-muted-foreground);
    font-size: 14px;
    line-height: 1.35;
}

.gs-order-bump-editor__choice.is-selected {
    background: var(--gs-active-soft);
    border-color: var(--gs-active);
    box-shadow: 0 0 0 3px var(--gs-active-shadow);
}

.gs-order-bump-editor__choice.is-selected span {
    border-color: var(--gs-active);
    box-shadow: inset 0 0 0 4px var(--gs-surface);
    background: var(--gs-active);
}

.gs-order-bump-editor__choice.is-disabled {
    opacity: .55;
    cursor: not-allowed;
}

.gs-order-bump-editor__bump-head,
.gs-order-bump-editor__empty {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin: 10px 0 16px;
}

.gs-order-bump-editor__content {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(260px, 320px);
    gap: 24px;
    align-items: start;
    width: 100%;
    min-width: 0;
}

.gs-order-bump-editor__form,
.gs-order-bump-editor__preview {
    min-width: 0;
}

.gs-order-bump-editor__preview {
    padding-left: 22px;
    border-left: 1px solid var(--gs-border);
}

@media (max-width: 980px) {
    .gs-order-bump-editor__toolbar,
    .gs-order-bump-editor__content {
        display: block;
    }

    .gs-order-bump-editor__select {
        width: 100%;
        margin-top: 12px;
    }

    .gs-order-bump-editor__activation {
        grid-template-columns: 1fr;
    }

    .gs-order-bump-editor__preview {
        margin-top: 22px;
        padding-left: 0;
        border-left: 0;
    }
}
</style>
